export const multipleChoicePoll = {
  type: 'object',
  properties: {
    options: {
      type: 'array',
      description: 'Keys der Antwortoptionen => "answer_[key]"',
      items: {
        type: 'string'
      }
    },
    answer: {
      type: 'array',
      items: {
        type: 'string'
      },
      description: 'Keys der richtigen Antwortoptionen => "answer_[key]"'
    }
  },
  required: ['options']
}
